
import Formatter from './formatter'
import { helpers } from '@moeco-platform/moeco-components'

const i18n = helpers.i18n

// Vue.use(VueI18n)

// User local initialized from user settings, which stored at auth-server

//USA, Canada, Australia, New Zealand, Philippines
const country12h = ['en-US', 'en-CA', 'fr-CA', 'en-AU', 'en-NZ', 'en-PH']


const dateTimeFormats = (locale) => {
  return country12h.includes(locale) ? {
    'en-US': {
      short: {
        year: 'numeric', month: 'short', day: 'numeric'
      },
      long: {
        month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric', hour12: true
      }
    }
  } : {
    'en-US': {
      short: {
        year: 'numeric', month: 'short', day: 'numeric'
      },
      long: {
        month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric', hour12: false
      }
    }
  }
}

i18n.applyTranslations = (locale) => {
  i18n._formatter = new Formatter({ locale })
  i18n.setDateTimeFormat('en-US', dateTimeFormats(locale)['en-US'])
}

export default i18n;
